import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Loader2 } from "lucide-react";
import { PilotFormFields } from "./PilotFormFields";

export function PilotEditDialog({
  open, onOpenChange,
  formData, setFormData,
  initiatives, partners,
  newPartnerName, setNewPartnerName,
  creatingPartner, onCreatePartner,
  onSubmit, loading,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Editar Piloto</DialogTitle>
          <DialogDescription>Modifica los datos del piloto</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <PilotFormFields
            formData={formData} setFormData={setFormData}
            initiatives={initiatives} partners={partners}
            newPartnerName={newPartnerName} setNewPartnerName={setNewPartnerName}
            creatingPartner={creatingPartner} onCreatePartner={onCreatePartner}
            idPrefix="edit"
          />
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
            <Button type="submit" disabled={loading}>
              {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Guardar Cambios
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
